import { useState } from 'react';
import { GiveReportTable } from './GiveReportTable';

type Tab = 'give';

const TABS: { key: Tab; label: string }[] = [{ key: 'give', label: 'Выданные УЕ' }];

/**
 * «Отчёты» — вкладками, как «Маркетинг» и «Журналы событий». Пока вкладка
 * одна: отчёт о выданных УЕ (Orchid ReportGiveListScreen). Отчёт о расходах
 * (ReportExpenseListScreen) в старой админке отключён в меню, поэтому не
 * переносился; когда понадобится — добавится второй вкладкой сюда.
 */
export function ReportsPage() {
  const [tab, setTab] = useState<Tab>('give');

  return (
    <section className="catalog">
      <header className="catalog__header">
        <h1>Отчёты</h1>
        <p className="catalog__lede">Кто, кому и когда выдавал у.е.</p>
      </header>

      <div className="card tabs">
        <div className="tabs__list" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`tabs__item${tab === t.key ? ' tabs__item--active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="tabs__panel" role="tabpanel">
          <GiveReportTable />
        </div>
      </div>
    </section>
  );
}
